export default __webpack_public_path__ + "static/media/shop.7416b4f9.svg";